import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class LockedOverlay extends Component {

  render() { 
    return (
      <div className="lock">
        <div className="lock-icon"/>
        <br />
        Upgrade to reinstate your locker.
        <Link
          to='/settings/payment-info/subscribe'
          className="cta cta-gradient upgrade-button"
          title="Upgrade Now">
        Upgrade Now
        </Link>
      </div>
    );
  }
}

export default LockedOverlay;


// WEBPACK FOOTER //
// ./src/components/Global/LockedOverlay.js